import ApiService from "../api.service"
import ESPHttpService from "../esp-http.service"

const encodeBase64Utf8 = value => btoa(unescape(encodeURIComponent(value)))

const AccountService = {
  GenerateToken(data) {
    return ApiService.post("/Account/GenerateToken", data)
  },
  GenerateTOTPRegisterationUri(data) {
    return ApiService.post("/Account/GenerateTOTPRegisterationUri", data)
  },
  ChangeUserLang(data) {
    return ApiService.post(`/account/ChangeUserLang`, data)
  },
  Logout() {
    // ponytail: read the token synchronously here — the caller clears
    // localStorage immediately and the async interceptor runs too late
    return ApiService.get("/account/Logout", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    })
  },
  GetUserInfo() {
    return ApiService.get(`/account/GetUserInfo`)
  },
  ChangePassword(data) {
    return ApiService.post(`/account/ChangePassword`, data)
  },
  ChangeUserInfo(data) {
    return ApiService.post(`/account/ChangeUserInfo`, data)
  },
  GetKeyForLoginSign(userName) {
    return ApiService.get(`/account/GetKeyForLoginSign?userName=${userName}`)
  },
  // Login kalitini imzolaydi va GenerateToken uchun { signedData, styxCertIssuer } qaytaradi
  async SignLoginKey(userName) {
    const keyResponse = await AccountService.GetKeyForLoginSign(userName)
    const signResponse = await ESPHttpService.signedData(
      encodeBase64Utf8(JSON.stringify(keyResponse.data)),
    )
    return {
      signedData: signResponse.data.signedMsg,
      styxCertIssuer: signResponse.cert?.issuer,
    }
  },
  RefreshToken(data) {
    return ApiService.post("/Account/RefreshToken", data)
  },
  IsRequireEsp(data) {
    return ApiService.post(`/account/IsRequireEsp`, data)
  },
  ChangePasswordByUserName(data) {
    return ApiService.post(`/account/ChangePasswordByUserName`, data)
  },
  ChangePhoneNumber(data) {
    return ApiService.post(`/account/ChangePhoneNumber`, data)
  },
  RequestPasswordReset(data) {
    return ApiService.post(`/account/RequestPasswordReset`, data)
  },
  CheckOTP(data) {
    return ApiService.post(`/account/CheckOTP`, data)
  },
  ConfirmPasswordReset(data) {
    return ApiService.post(`/account/ConfirmPasswordReset`, data)
  },
}
export default AccountService
